import React, { useContext, useState } from 'react';
// import { TezosToolkit } from '@taquito/taquito';
import { TempleWallet } from '@temple-wallet/dapp';
import { TezosToolkit } from '@taquito/taquito';
export const WalletConnect = React.createContext({});
export const useWalletConnect = () => useContext(WalletConnect);

// const Tezos = new TezosToolkit('https://testnet-tezos.giganode.io');

const options = {
  name: 'MyAwesomeDapp',
  iconUrl: 'https://tezostaquito.io/img/favicon.png',
  preferredNetwork: "granadanet",
  eventHandlers: {
    PERMISSION_REQUEST_SUCCESS: {
      handler: async (data) => {
        console.log('permission data:', data);
      },
    },
  },
};

export const Web3Provider = ({ children }) => {
  const [account, setAccount] = useState('');
  const [provider, setProvider] = useState();

  const connectWallet = async () => {
    try {
      const available = await TempleWallet.isAvailable();
      if (!available) {
        throw new Error("Temple Wallet not installed");
      }

      const wallet = new TempleWallet("My Super DApp");
      await wallet.connect("granadanet");
      const tezos = await new TezosToolkit('https://granadanet.smartpy.io');
      tezos.setProvider({wallet});

      console.log("here")

      const accountPkh = await tezos.wallet.pkh();
      const accountBalance = await tezos.tz.getBalance(accountPkh);
      setAccount(accountPkh);
      setProvider(tezos);
      console.info(`address: ${accountPkh}, balance: ${accountBalance}`);
    } catch (err) {
      console.error(err);
    }
  }

  const disconnect = async () => {
    // todo: disconnect
  }

  return (
    <WalletConnect.Provider
      value={{
        account,
        provider,
        disconnect,
        connectWallet,
      }}
    >
      {children}
    </WalletConnect.Provider>
  );
};
